import styled from 'styled-components';
import MuiDialog from '@material-ui/core/Dialog';
import { Color, borderRadius } from '../Theme';

export const StyledDialog = styled(MuiDialog)`
  .MuiDialog-paperScrollPaper > div {
    margin-bottom: 0;
    box-shadow: none;
  }

  @media (max-width: 640px) {
    .MuiDialog-paper {
      margin: 0;
      width: 100%;
      height: 100%;
      max-width: none;
      max-height: none;
      border-radius: 0;
      box-shadow: none;
    }
  }
`;

export const Dialog = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem;
  width: 600px;
  min-height: 200px;
  max-height: 100%;
  border-radius: ${borderRadius}px;
  background-color: ${Color.white};

  box-sizing: border-box;

  @media (max-width: 640px) {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
`;
